import 'swiper/css';

import React from 'react';
import { FreeMode } from 'swiper';
import { Swiper } from 'swiper/react';

const Slider = (props) => {
  const { children, spaceBetween = 16, name = '' } = props;

  return (
    <Swiper
      effect={'cards'}
      resistance={true}
      resistanceRatio={0}
      slidesPerView='auto'
      spaceBetween={spaceBetween}
      noSwiping={true}
      noSwipingClass={'swiper-slide'}
      freeMode={{
        minimumVelocity: 0.02,
        enabled: true,
        momentum: true,
        momentumBounce: false,
        momentumRatio: 0.8,
        momentumVelocityRatio: 0.6,
      }}
      modules={[FreeMode]}
      className={`sliderSwiper ${name}`}
      onSlideChange={() => console.log('slide change')}
      onSwiper={() => null}
    >
      {children}
    </Swiper>
  );
};

export default Slider;
